import { Link } from "react-router-dom";
import { ShoppingBag, MessageCircle, ArrowUpRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { TextileVisual } from "./TextileVisual";

export function ProductCard({ product, onAddToCart, onWhatsAppOrder, featured = false }) {
  return (
    <article className={`product-card ${featured ? "product-card--featured" : ""}`} data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="product-card__visual-link" data-testid={`product-visual-link-${product.slug}`}>
        <TextileVisual visualKey={product.visual_key} label={`${product.name} textile placeholder`} testId={`product-visual-${product.slug}`} />
      </Link>
      <div className="product-card__body">
        <div className="product-card__meta">
          <Badge className="umeed-badge" data-testid={`product-story-tag-${product.slug}`}>{product.story_tag}</Badge>
          <span className="product-card__status" data-testid={`product-stock-${product.slug}`}>{product.stock_status}</span>
        </div>
        <Link to={`/product/${product.slug}`} className="product-card__title-link" data-testid={`product-title-link-${product.slug}`}>
          <h3 data-testid={`product-name-${product.slug}`}>{product.name}</h3>
        </Link>
        <p data-testid={`product-description-${product.slug}`}>{product.short_description}</p>
        <div className="product-card__price-row">
          <strong data-testid={`product-price-${product.slug}`}>₹{product.price.toLocaleString("en-IN")}</strong>
          <Link to={`/product/${product.slug}`} data-testid={`product-details-link-${product.slug}`}>
            Details <ArrowUpRight aria-hidden="true" />
          </Link>
        </div>
        <div className="product-card__actions">
          <Button className="btn-primary" onClick={() => onAddToCart(product)} data-testid={`add-to-cart-button-${product.slug}`}>
            <ShoppingBag aria-hidden="true" /> Add to Cart
          </Button>
          <Button className="btn-quiet" variant="outline" onClick={() => onWhatsAppOrder(product)} data-testid={`whatsapp-order-button-${product.slug}`}>
            <MessageCircle aria-hidden="true" /> WhatsApp
          </Button>
        </div>
      </div>
    </article>
  );
}